import { render, staticRenderFns } from "./FiltroValidacao.vue?vue&type=template&id=b2505310&scoped=true&"
import script from "./FiltroValidacao.vue?vue&type=script&lang=js&"
export * from "./FiltroValidacao.vue?vue&type=script&lang=js&"
import style0 from "./FiltroValidacao.vue?vue&type=style&index=0&id=b2505310&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2505310",
  null
  
)

export default component.exports